import React from 'react';
import { motion } from 'framer-motion';
import { dummyExercises } from '../data/dummyData';
import MediaPlaceholder from './MediaPlaceholder';
import SafeIcon from '../common/SafeIcon';
import { FiSearch, FiFilter } from 'react-icons/fi';

export default function Library() {
  return (
    <div className="space-y-8 pb-12">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-6">
        <div>
          <h2 className="text-3xl font-bold text-white tracking-tighter flex items-center gap-3">
            <span className="text-gray-600 font-mono text-sm">ARCHIVE_</span>DATA.BANK
          </h2>
          <p className="text-sm text-gray-500 font-mono mt-1">Found 1,024 Verified Movement Nodes</p>
        </div>
        <div className="flex w-full md:w-auto gap-3">
          <div className="relative flex-1 md:w-64">
            <SafeIcon icon={FiSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" />
            <input 
              type="text" 
              placeholder="Filter Nodes..." 
              className="w-full bg-carbon-800 border border-carbon-700 rounded-xl pl-10 pr-4 py-2 text-xs font-mono text-white focus:border-lime-500 transition-colors"
            />
          </div>
          <button className="bg-carbon-800 border border-carbon-700 p-2.5 rounded-xl text-gray-400 hover:text-white transition-colors">
            <SafeIcon icon={FiFilter} />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {dummyExercises.map((ex, i) => (
          <motion.div 
            key={ex.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.05 }}
            className="glass-panel overflow-hidden group border-carbon-700/50 hover:border-lime-500/30 transition-all duration-500 flex flex-col h-full"
          >
            <div className="h-44 shrink-0">
              <MediaPlaceholder category={ex.category} difficulty={ex.difficulty} />
            </div>
            <div className="p-5 flex flex-col flex-1">
              <div className="flex justify-between items-start mb-2">
                <h3 className="text-white font-bold group-hover:text-lime-500 transition-colors text-sm leading-tight pr-4">{ex.name}</h3>
                <span className="text-[9px] font-mono text-gray-600 shrink-0">#{ex.id}</span>
              </div>
              <div className="mt-auto pt-4 flex flex-wrap gap-2">
                <span className="text-[9px] font-mono uppercase bg-carbon-900 text-gray-400 px-2 py-1 rounded border border-carbon-700">
                  {ex.muscle}
                </span>
                <span className="text-[9px] font-mono uppercase bg-carbon-900 text-lime-500/80 px-2 py-1 rounded border border-lime-500/20">
                  {ex.load}
                </span>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}